module.exports = __webpack_public_path__ + "img/Icon - Best Score.741da6ca.svg";